import React from 'react';

function TdPermission(props) {
    return (
        <td {...props} hidden={props.hidden}>{props.children}</td>
    )
}

export default TdPermission;
